module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("August, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OUG")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("STOOD")]), _vm._v(" at the back of the bar, in Blaine’s office, with his left hand cupped over his ear. He listened carefully as the doctor explained what the most recent series of tests meant. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Cardiomyopathy. Dilated cardiomyopathy")]), _vm._v(", to be precise.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What does this mean, doc?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s hard to say—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Then just guess,” Doug shouted, failing to hold onto what little composure he had left. “I’m sorry, Dr. Graves. I’m very sorry. It’s just all so….”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Listen, Doug. You know I’m not going to hold anything against you. I can’t even begin to imagine what your life has been like, losing your mother and now your brother. Please, let me refer you to someone who can help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, thank you, Dr. Graves. I’ll be fine. How much time does Paul have?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“A year, maybe eighteen months.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank you, doc.” The tears came almost immediately, but he managed to keep it together so he could apologize to the doctor one more time and then bid him good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug Johnston hung up the phone and fell into Blaine’s chair, telling himself that none of it should be a surprise. The doctors had predicted a year or two for their mother, but she’d hung on for almost seven. Dr. Graves had given Paul until his twenty-fifth birthday, but Paul would turn thirty in two months. The will to live and thrive was strong in his family. Well, on their mother’s side, anyway. After he’d divorced their mother, Doug and Paul’s father had quickly remarried and lived in Europe, somewhere. Doug had his address at home but would be hard-pressed to find it. What’s worse was that Doug would never allow himself to look for it, even if he needed to. If his father missed a payment of any kind, Doug just called the lawyers.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Dougie?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He looked up to see Blaine standing in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sorry,” Doug said, wiping at his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sorry, nothing,” Blaine said as he closed the door and came to kneel near his friend and employee. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Test results are in.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That bad, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“The doctor says a year, maybe eighteen months.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yeah,” Blaine harrumphed. “And this is the same doctor who said he wouldn’t make it past twenty-five.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t know,” Doug said. He appreciated Blaine’s warm hand stroking his forearm. “Paul’s been really lethargic and fatigued lately. The doctors noticed his more-than-usually irregular heartbeat. And you’ve seen how swollen Paul’s legs are getting.” Doug checked his watch and jumped out of the chair. “Sorry, I didn’t mean to be gone this long.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Pinky’s covering your tables,” Blaine said, waving in the general direction of the bar. “He can use the practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Give him a break, Blaine. He’ll get better. Try encouraging him instead of yelling at him all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I know, I know,” Blaine said, whipping his hands back and forth in front of his face as if he were wiping away all of his negative thoughts. “The husband is always telling me to be nicer to the employees, and there wouldn’t be this turnover problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“This employee agrees,” Doug said as he bent to kiss his boss on the cheek. “I’m okay now. Thank you. I’ll get back out there and keep an eye on Pinky for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You’re an absolute doll. And if you need anything, you just tell me what, when, where, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug nodded and headed back to the floor to retrieve his tray from behind the bar. He put on his usual smile and walked by his first two tables. Everyone good. The third and fourth tables asked for refills. Doug nodded and moved to table five. He cringed when he heard the two bottle blonds cackling like witches. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("God, please don’t let me have to cut anyone off tonight. Not tonight, please.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“How are we doing here, gentlemen?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hey, let’s get him to settle the bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“May I get you anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yeah,” the skinny, peroxided blond said as he spun around in his chair and placed a hand on the arm of the large, bald man across the table. “Carson? Stand up, so he can get a good look at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug continued to smile as the dark-haired man sitting beside the blond interrupted. “Michael—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s Michel,” the blond said, his smile disappearing instantly.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Not on your birth certificate. Now, knock it off and leave him alone, before we get kicked out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, please,” the blond snorted. “This place? They wouldn’t throw a leper out of this dump.” The blond rebounded quickly, once again giggling and laughing. He turned to see that Doug’s smile had disappeared. “No offense, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“None taken… honey,” Doug said, matching the blond’s tone. “So, there’s nothing else for you gentlemen?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“We were just trying to figure out why Carson is such a catch,” the blond said, laughing hysterically. He was now joined by the other bottle blond, who had his hand over his mouth as if he were some sort of geisha. “I say it’s his blindingly white Chiclet teeth, and Gregoire thinks it’s because his ass gets its own area code.” More laughter, complete with snorting. Doug sighed, wondering if Gregoire was actually French or just decided to be obnoxiously pretentious and change his name from Gregory to Gregoire. Regardless, Doug knew them, probably better than they knew themselves—two social media whores who thought that the “news” referred to the latest gossip about some talentless chick’s new gown, or who honestly believed that it was their solemn duty to point out everybody’s flaws while completely ignoring their own. The type who clung furtively to a code of clothes, hair, and weight as the only things of any importance in life. Doug looked at Carson and offered a smile, fighting the urge to say that Carson’s best feature was obviously his patience.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Carson, is it?” Doug leaned down a little closer, so he could whisper into the man’s ear. His friend leaned in to listen. “I’ll let it go this time, but you really shouldn’t be bringing your poodles into a bar.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("The dark-haired man sitting beside Carson burst out laughing and held up his hand, expecting a high five from Doug, who took the opportunity to put the bill in it and walked away to check on his remaining tables. He could hear the blond twins still bitching and whining as he passed by on his way to the bar to fill his new orders. The one named Gregoire was speaking animatedly to Pinky—complete with hand gestures—by the time Doug walked by again, offering an exaggerated smile to give Blaine the heads-up.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug and Blaine were leaning on the bar when Pinky finally arrived, flustered and looking as if he’d taken on several bikers at once in the men’s room. “Doug, what did you say to those customers? They want to speak with your manager, right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Got it,” Blaine said as he took a few steps away from the bar and turned. “Hope they’ll be okay with speaking to the owner.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug stood at the bar, leaning and smirking, enjoying himself immensely. Blaine would go over and ask, precisely, what Doug had done to upset them. They would go through their story, convinced that Blaine would comp their entire night and promise the best possible service whenever the bar was privileged enough to have their company in the future. Then, they would demand that Doug, the rude waiter who insulted them, be fired or disciplined, so they could smile smugly at him as they exited.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Unfortunately for the Bitchy Twins, Doug had worked in the bar, in one capacity or another, since his senior year of high school. And to make matters worse, Doug had learned a very long time ago to offer insults that could not, technically, be construed as insults. Doug had said nothing "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("to")]), _vm._v(" the twins, but if they overheard the comment? Well, Doug could hardly be faulted for "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("their")]), _vm._v(" eavesdropping. Blaine would listen carefully as one of the blonds squealed his outrage at being referred to as a pet and the way Doug had implied that he wasn’t worthy of Carson’s friendship. Then, Blaine would ask them if Doug had actually called the blond a pet to his face, to which Our Lady of the Single Syllable would have to confess that Doug had not, in fact, addressed him, except to ask for his drink order. Blaine would feign confusion for a moment or two and then ask the blonds how they could possibly know what Doug had said about them in a loud, crowded bar.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("It would all end with Blaine doing nothing, the blonds getting nothing, and Doug being rid of them earlier than expected. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Good enough for me,")]), _vm._v(" Doug thought as Blaine made his way back, raising his hand in the air. Doug obliged him with a high five and laughed when the owner delivered his usual “Grasshopper almost as good as Master” before heading to his office or out the back for a smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug picked up his tray and headed over to Pinky, who was mopping his brow like some abandoned southern belle wondering how she was ever gonna show her face in polite society.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hey, Pinky,” Doug said, taking the disheveled waiter’s tray. “Blaine said you could leave early. Go and have some fun. I’ll give your tips to Blaine to keep in the safe for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Oh, thank you.” Pinky’s relief was almost palpable. He hugged Doug and then headed to the back to drop off his apron and pad.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug turned at the voice, almost dropping the two trays. The man named Carson was standing in front of him, bending over suddenly when it appeared that Doug would drop one, or both, of the trays.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“I wanted to come over and thank you for what you said.” Carson seemed awfully nervous. So Doug smiled and held out his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m Doug,” he started and then felt himself blushing. “My mother was a huge fan of your show on television.” Doug let go of Carson’s hand and led him toward the little alcove of office doors near the back of the bar. “Sorry, hard to hear out there.” The light was a little better near the offices, and Doug could see a few bruises on Carson’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m Carson—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oliver. Yes, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You recognized me?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Not at first, but then, after all that,” Doug said, waving his hand in the direction of the table. “I noticed you smile, and then I knew "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("exactly")]), _vm._v(" who you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’ve changed quite a bit since then,” Carson said, wringing his hands as his eyes darted back and forth between Doug’s eyes and the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t know about ‘quite a bit,’” Doug said, feeling feeble and caught off guard. “I mean, you’ve got a buzz cut now, but you still have those beautiful blue eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And about an extra fifty pounds,” Carson said, folding his arms over his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And that mesmerizing smile.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson’s self-effacing smile disappeared, and his eyebrows went up suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry,” Doug said and put a hand on Carson’s forearm. “I’m not usually this forward.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Right. Okay,” Carson stammered. “Well, I guess I should be going.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug removed his hand and smiled. “It was nice finally getting to meet you, after all these years.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good night, uh?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Doug.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, good night, Doug.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He nodded and watched Carson turn and walk away. He leaned against the wall just as Blaine came back from smoking a cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, well. Did we get a phone number?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I wish,” Doug said, not bothering to look at Blaine. “Why can’t I find a man like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You just did,” Blaine said.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“By the way, I told Pinky you told me to tell him he could leave early.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I keep forgetting that you’re the owner of this bar and not me,” Blaine said snidely, glared at Doug, and walked away. Doug laughed at the expression on Blaine’s face and went back to making the final round of all of his—and Pinky’s—tables.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("“I")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("TOLD")]), _vm._v(" Pinky you’d keep his tips in the safe.” Doug held out the wad of bills and waited for Blaine to take them.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I meant to ask you before,” Blaine said, taking the bills and stuffing them in an envelope. “Did the doctor tell you when Paul can come home?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Please let me know if there’s anything I can do.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I will, sweetie, and thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Do you want me to drive you home?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, thanks. The walk always helps me clear my head.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay. Hugs and kisses to Paul when you see him tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug nodded, walked to the locker room, retrieved his coat, headed out the front door, and said good night to Carlos, the bouncer. It was still warm enough that he didn’t need the coat, and the rain they were promised had yet to materialize, so Doug threw the coat over his shoulder and headed the four blocks to his house.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("It became his house when his mother died, leaving him and Paul alone. Doug had been teaching for five years by the time his mother died, but decided to leave the profession and go back to working full-time at the bar. He figured if he worked evenings, he’d have his days free to take care of Paul, chauffeur him to his medical appointments, and spend more time with him before he was taken as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He crossed the street, blinking rapidly, trying to force himself to think of something else. Then he heard his name. He turned around and saw Carson standing in the bar’s parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Carson?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sorry. Didn’t mean to scare you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That’s okay,” Doug said as he walked back to stand in front of him. “Did you forget something?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“No, well, yes,” Carson said, wringing his hands again—or was it still? “I mean, I was just wondering if I could give you a ride home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Doug pointed over his shoulder. “Well, I only live a few blocks that way, but if you don’t mind such a short trip, I won’t say")]), _vm._v(" "), _c('span', {
    staticClass: "t17"
  }, [_vm._v("no")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, okay,” Carson said. He opened the passenger-side door of his Lexus, waited for Doug to be seated and closed it gently.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug sat in the passenger seat, smiling at this sudden, strange turn of events. He looked over as Carson settled himself in the driver’s seat and started the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Where to, exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t18"
  }, [_vm._v("“Harcourt Avenue. Take Broadway to Harcourt and then turn left.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Broadway, Harcourt, left. Got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug fastened his seatbelt and turned to face Carson. “I hope I didn’t make you uncomfortable back there?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No. Well, sort of,” Carson said, shrugging his shoulders. “It’s been a while since a good looking man has flirted with me. I’m a little out of practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I was. Flirting with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Right here?” Carson asked, pointing to Harcourt Avenue.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Which house?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“The white one with blue trim.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What did you mean by "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("finally getting to meet me after all these years")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“This is it,” Doug said as Carson slowed and pulled into the driveway. “Do you recognize this house?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson studied the house for a moment and then shook his head. “Should I?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Follow me,” Doug said as he opened his door and hopped out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson did not move from his seat. Doug waited, prepared to go back and explain, but he so wanted Carson to see the backyard. Just as he resigned himself to going back to sit in the car, Carson opened his own door.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’ll stay right here, by the car, in case you think I’ll try anything. I just wanted to show you the backyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You designed it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I did?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes. Many years ago, when your program was just starting, a woman wrote a letter to you. She asked for your help in creating the garden she always wanted. She didn’t have a lot of time left and wanted to see it completed before she passed.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Mrs. Johnston,” Carson whispered to himself as he looked toward the backyard.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Molly. Yes, that’s her.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That was the third episode we did.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Please.” Doug walked toward the backyard and opened the gate. “I’ll just turn on the lights.” He disappeared into the house through the backdoor and flipped a few switches, bathing the backyard in the soft glow of halogen lamps.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I remember this,” Carson said, showing that intoxicating smile. “There was a little boy, about ten years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Twelve,” Doug corrected. “That was Paul, my younger brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He walked with crutches.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He has muscular dystrophy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s okay,” Doug said, blinking rapidly again. “You didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It looks exactly the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Once you were done, my mother was out here every day, making sure it stayed just as you designed and built it all. Now that’s my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“She’s gone now?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes,” Doug said softly and gnawed at his lower lip. “Ten years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m so sorry,” Carson turned and looked at Doug, who could see the compassion and understanding. “Around the same time I lost my dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“My condolences.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson nodded and looked around the backyard again. “Wait,” he said. “I don’t remember two sons.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I was at university. I couldn’t make it back to be part of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Another nod of understanding from Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Could I convince you to come in and have a coffee or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s already midnight,” Carson said, wringing his hands again. “You don’t mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I wouldn’t have asked if I minded.” Doug opened the back door and let Carson pass, the smell of his cologne, the desire to reach out and touch his perfect skin almost too much to bear. “Please. The living room is this way.” Doug led Carson through the kitchen and into the living room. “Make yourself at home. I’ll just go make the coffee. Or would you prefer tea?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Tea would be great. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug threw his backpack on the table and took a few deep breaths. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("He is in my house.")]), _vm._v(" Doug could almost hear his mother laughing. He’d confided in her how attractive he’d always found Carson Oliver and how disappointed he was that he couldn’t get back to meet him during the renovation of the backyard. “He’s just a man, sweetie,” she said. Doug rolled his eyes and explained again how tall, dark-haired, blue-eyed men with million-dollar smiles were not so easy to find. But she shook her head and told him he’d never found one because he never took his head out of his textbooks.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Is there anything I can help with?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sorry?” Doug was caught unawares, again. “Oh, no. Thank you. Almost done.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t mean to pry, but is your brother sleeping?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No,” Doug said, turning his face to the coffee maker. “He’s in the hospital right now. He’s going through a rough patch. I’ll be going to bring him home tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry, Doug.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“He’s a big fan of yours too. You built that ramp and that bridge over the little water feature. You’re all he could talk about for months.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I remember him, I think,” Carson said as he crossed his arms over his chest and leaned against the wall. “Blond hair, green eyes, mischievous smile?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That’s him,” Doug said with a snort. “That is definitely him.” Doug took two mugs out of the cupboard and turned to Carson. “Milk? Cream? Sugar?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Just black, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Me too. Shall we?” Doug led Carson back to the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Once they were seated on the sofa, Doug looked up when Carson cleared his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t mean to overstep any boundaries here, but do you think your brother might like another visitor tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug smiled and studied his black coffee, blinking rapidly. “We would both like it,” he said, completely enthralled with Carson’s smile.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OUG")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OPENED")]), _vm._v(" the door and saw Carson’s smiling face. His heart skipped a beat at how beautiful he was. Carson was dressed in a pair of black jeans, an untucked, white button-down shirt, and pair of white Keds.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good morning, Carson. Thank you for doing this. Paul is not going to believe this.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m happy to do it,” Carson said as he stepped inside the house. “Listen, Doug. I was wondering if I might take the two of you to lunch… or brunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug stopped double checking the contents of his backpack and looked at Carson. “That’s really very sweet of you, Carson, but Paul’s wheelchair takes up a lot of room, so…. And besides, Paul loves picnics. His favorite thing is to eat in the backyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s a date, then,” Carson said, wringing his hands. “I’ll bring you two back here, and then I’ll run out and put together a nice welcome-home picnic for Paul.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He looked at Carson, wondering if he was just being especially kind or if he was just beginning to understand the depth of Doug’s attraction. “Okay. It’s a date, then. Thank you, Carson.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, not a date, really,” Carson said as Doug led the two of them out of the house. “More like a….”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Picnic?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, sure. A picnic.” Carson said, heading to his car.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Carson,” Doug pointed to the garage behind the house. “I’ll need to use the van.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course,” Carson said, slapped his forehead, and followed Doug to the back alley. “Sorry about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Not a problem,” Doug said. He opened the garage and held Carson’s door for him. “So, why not a date?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Why is this not a date? I mean, do you not date? Do you have a boyfriend, or a husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No. I’m single, completely unattached,” Carson said, wiping his palms across the denim on his thighs. “But certainly, you must have someone special.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t19"
  }, [_vm._v("“Besides Paul, no.” Doug started the van, pulled out of the garage, and stopped in the alley so he could hop out and close the garage door. Doug got back in the van and felt the tension almost immediately.")]), _vm._v(" "), _c('span', {
    staticClass: "t20"
  }, [_vm._v("Maybe I should have kept my mouth shut")]), _c('span', {
    staticClass: "t19"
  }, [_vm._v(". He put the van in gear and continued to the main street that would take them to the hospital.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I didn’t mean to offend you, Doug,” Carson said as they approached the hospital. “I didn’t want to presume that someone like you would go out with someone like me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Someone like you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yeah. You know, the kind of men who always get turned down by men who look like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Always?” He looked at Carson as they sat at a red light. The man with eyes like sapphires and a smile that could melt the coldest of hearts was nodding. “I bet you’re wrong. Go ahead, ask me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course you’ll say "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("yes")]), _vm._v(" now just to win the bet, just to prove me wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“We haven’t even agreed on the stakes, so what is there for me to win? Ask me out. Please.” Doug pulled the van into the hospital parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay,” Carson said, obviously humoring him, like he would a five-year-old. “Doug? Would you like to go out with a bald, fat man who still lives with his mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t21"
  }, [_vm._v("The look on Carson’s face, the fading smile, made Doug want to kiss the confidence back into him. He leaned over the center console and put his hand in Carson’s. “As long as he’s you.” He squeezed Carson’s hand. “You obviously don’t see what I do. I want to go out on a date with a handsome man who’s tall, elegant, charming, compassionate, and who either doesn’t know that or has forgotten it somewhere along the way.” Doug leaned over a little more and kissed Carson on the cheek, then returned to his side of the van.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson blushed. When Carson didn’t say anything, Doug opened his door and hopped out.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Before closing the door, he looked back inside. “You can even pick the place, and I’ll pay.” Doug slammed the door, petrified that his heart would beat itself right out of his chest. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("God, please, don’t let him cancel or chicken out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug began to walk toward the entrance to the hospital, hoping that Carson was right behind him. He didn’t want to turn around and look. As he approached the automatic sliding doors, a hand brushed his and he offered Carson a smile. “Thank you,” Carson said softly as they walked to the elevators. “That’s the nicest thing anyone has said to me. Besides my parents, that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What kind of friends do you have?” Doug asked a little too loudly and turned to face him. “Sorry, didn’t mean for that to be so loud.” He recovered and added, “I meant every word, Carson.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("The doors to the elevators opened and they stepped inside, neither speaking for the short ride to the third floor. Doug led the way to the east wing and to room 313. He entered the room to find Paul waiting for him, already in his wheelchair.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“There you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hey, buddy. How are you feeling today?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good,” Paul said, his bright green eyes moving past his brother and finding Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Paul, do you remember Carson Oliver?” Doug asked. He stepped aside and touched Carson’s forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course,” Paul said with a huge smile. “The guy who made Mom’s dream come true.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“It’s nice to see you again, Paul,” Carson said, holding out his hand. Doug was about to tell Carson that Paul had no motor control over his arm, but the man must have realized it. He took Paul’s closed fist and squeezed it gently. “I remember working with you and your mom.” Carson smiled and bent over so he and Paul could be eye to eye. “I remember a certain twelve-year-old who kept a very close watch on things, making sure I did exactly what his mom wanted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Paul’s lips curved into something like a smile and he snorted. “Doug wasn’t there, so I had to take care of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t19"
  }, [_vm._v("“You did a great job, Paul.” Carson stood up and looked at Doug.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You ready to go, baby brother?” Doug put a hand on his brother’s shoulder and looked up to offer a smile to Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes, big brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, then,” Doug said as he took the duffle bag off the bed. “Carson and I have a nice surprise for you when you get home.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It wouldn’t be a surprise if we told you, now would it?” Carson was walking beside the wheelchair, one hand resting on Paul’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OUG")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("GOT")]), _vm._v(" his brother settled into his room as Carson rounded up everything for the impromptu picnic.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Are you tired? Do you want to nap for a bit?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No,” Paul said, trying to shake his head.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Did Dr. Graves come to see you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And what?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What did he tell you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That I shouldn’t bother training for that marathon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug snorted and sat on the bed, opposite his brother. “If you don’t want to talk about it, that’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What’s to talk about? They’ve been giving me that year or eighteen months stuff every visit, every therapy session, every ventilatory checkup for five years.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, good, then,” Doug said, pushing to his feet and tousling his brother’s hair. “You’re stuck with me forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Where’s my surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s coming. You just need to be patient.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Can I be patient in the backyard?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That sounds like the perfect place to be today,” Doug said as he moved behind the wheelchair. “Do you want to take a blanket, just in case?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, but if you start to feel tired, you make sure to tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug reached the deck in the backyard, positioned his brother’s wheelchair by the table, and fiddled with the umbrella so the sun would not be in their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“No. I wanna be in the sun,” Paul protested, glaring at his brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay,” Doug said, realizing he would need to go get sunscreen and a hat. “Don’t move.” He wasn’t saying it to be cruel, or even out of habit. It was a little inside joke between the two of them. He headed inside.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("When he returned to the backyard, he found Paul’s wheelchair right in the middle of the deck.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t18"
  }, [_vm._v("“Okay. How’s that?” Carson asked as he stepped from behind Paul.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug noticed Carson look up, seeing him for the first time since returning. “This is okay, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course,” Doug said with a sincere smile. “I just went in to get some sunscreen and his hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Paul,” Doug said, as soothingly as he could. “It’s either the umbrella or the hat. You choose.” Doug smiled for Carson and waited.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Fine. Give me the hat,” Paul groused. “Makes me look like Gilligan.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I loved that show,” Carson cooed as he stood watching.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good choice,” Doug said. He plopped it on his brother’s head and then turned his attention to the application of the sunscreen.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Ah, I got a bunch of different things. I wasn’t really sure what Paul likes, or you, for that matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Paul "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("loves")]), _vm._v(" everything. Isn’t that right, Paul?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Except olives, spinach, anchovies, and salmon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t think I bought anything with those ingredients, but… I got some potato salad and some deli sandwiches. I didn’t know about—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Don’t be silly,” Doug said. He finished one of his brother’s arms and moved on to the other. “There’s more than enough in the fridge if he doesn’t eat what you’ve brought. Problem solved. Right, Paul?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Problem solved.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay,” Carson said. “I’ll go get things ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“We’ll be right here.” Doug watched as Carson picked up the three plastic bags and headed inside. When he’d finished smothering his brother’s face with lotion, Doug brought over two chairs and one of the little side tables, so there would be a place for all the plates and cups. He sat in one of the chairs, close beside his brother, his hand stroking Paul’s right arm. He thought about what the doctor had predicted and fought back tears. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Please, let it be painless")]), _vm._v(". "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Please don’t let him suffer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Doug looked at his brother’s handsome face. It was like a steel trap sometimes. Paul had odd moments where he would pick and choose what to share with him. And they were becoming more and more frequent, which had Doug scared. He tried broaching the subject before and after every visit, but Paul usually just shut him down. On impulse, he leaned over and kissed his brother’s cheek. Then he walked toward the back of the garden, the tears coming quickly. He took a few deep breaths and tried to calm down. Paul’s last year would not be filled with memories of his brother feeling sorry for himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Here we go,” Carson announced as he exited the house with a tray of plates and empty cups and a big jug of iced tea.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug turned around briefly and then looked back toward the alley and wiped his eyes and cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Doug?” Carson approached him. “Are you okay? Did something happen? Should we go back to the hospital?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No. No, I’m fine,” Doug said, turning to face Carson. “Thank you so much for the picnic. Paul loves picnics.” Doug reached out, rested his hand on Carson’s forearm for a brief moment, and headed back to the deck, and his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("“O")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("KAY")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(", P")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("AUL")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(".")]), _vm._v(" Mrs. Henry is here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hi, Mrs. Henry.” Paul had a sincere smile for the nurse, or as close as he could get to one. She stood in front of his chair and caressed his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I missed you, Paul,” Mrs. Henry said as she stood straight and looked at Doug. “Good day? He looks so happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“We had a picnic when we got back from the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“A picnic? My, my. And we all know how much Paul loves picnics.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Doug made me wear a hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Did he? Well, I’ll talk to him about that,” Mrs. Henry said. She squeezed Paul’s hand and sat down in the chair beside him. “So, what are we going to do tonight while your brother is working? Computers? Movies?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Can we watch "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Thor")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Again?” Mrs. Henry feigned surprise. “You should know that movie by heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, Paul. I’m going to work.” He leaned down and kissed his brother’s cheek. “I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Love you, big brother. Be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug said his good-byes to Mrs. Henry and reminded her that she should call the bar if there were any problems. She nodded and closed the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He stood outside the back door for a moment, trying to catch his breath. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Please don’t let him suffer.")]), _vm._v(" It was a thought that started to come back and visit him more and more, and not just because of the doctor’s prognosis. He was amazed that he was able to function some days. It was all he could do not to sink to the floor and sob about losing the last bit of family he had. And that usually led to Doug thinking about the one family member no one would have been sad to see die.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("As he walked to the bar, he thought again about his chat with Blaine. While she was alive, his mother had always been adamant that their father be contacted and told about Paul’s death. Doug had argued enough, pointing out that he’d been living in Europe, raking in ridiculous amounts of money with his new business, and had never seen fit to spend any of it visiting his first two children. He just sent checks every now and then, probably to assuage the guilt, Doug assumed. Invariably Doug’s mother would tell him to be more of a man than his father, and this would cause Doug to storm off before he said, or did, something he would regret—like pointing out that it would be difficult to be less of a man than his father.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Blaine was clearly on the side of not informing the absentee father, and Doug had been glad of the company. But as the time drew closer, Doug wasn’t so sure that he was right.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He arrived at the bar with fifteen minutes to spare before his shift began. Blaine was at the front, discussing something with Carlos, the bouncer.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Evening, gentlemen,” Doug said, tipping an imaginary hat.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Wait for me,” Blaine said. He ran to catch up to Doug. “So? How’s Paul?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He’s doing well, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You think?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You know how Paul is after his visits to the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Doesn’t want to talk, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Nope,” Doug said. He pushed open the locker-room door with what may have been too much force.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, honey. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I know. Everybody’s sorry.” Doug threw his backpack on the bench in the center of the room and ran a hand through his hair. “I apologize. Please, feel free to ignore me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No chance of that happening.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug turned, feeling confused and frustrated. “I hate to say it, but I think he’s given up.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Maybe he’s just having a blue day. I mean, we all go through them, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I hope that’s all it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Blaine came over and wrapped his arms around Doug. “Would you like a few days off?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No,” Doug said, kissing Blaine’s temple. “It all seems to be out of my control, so I guess I’ll just have to deal with whatever happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("The phone inside the locker room rang, and Blaine moved to answer it. Doug continued to get changed for his shift, not really listening to the conversation. He was fixing his apron when Blaine hung up the receiver, opened the locker room door, and stood in front of it to keep it open. Doug was about to ask Blaine what he was doing when Carson appeared in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’ll leave you two alone,” Blaine said with a sincere smile and a wink for Doug.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Carson? What—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry to bother you, but I, uh, I….” He was looking at his shoes. Doug’s heart began to beat faster. “I’m sorry. I rehearsed this all the way over here, but, well, the dashboard is a lot less, uh, well, intimidating than you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug smiled and tried not to laugh. “Are you okay? Is something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, not really,” Carson said, wringing his hands. “It’s about what you said earlier in the van, before we picked up your brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“When you asked me to ask you out on a date.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I know you were just trying to make me feel better. And I thank you for that, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Carson,” Doug said as he approached Carson, who looked befuddled. “If you felt better, that was just an unexpected benefit. What I said is how I feel about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You don’t even know me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I know enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m not the same person I was all those years ago. The man who helped your mother, the television star—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Is the same man who came with me to get my brother and who spent the afternoon talking with him, trying to make him laugh and feel better.” Doug took Carson’s hand. The heat and softness almost made him forget what he wanted to say. “If you don’t want to go out with me, I’ll be fine. I mean, I’ll be disappointed, but fine nonetheless. But please don’t doubt that I find you incredibly attractive.” Doug waited for a moment to let that sink in.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson leaned forward and framed Doug’s face with his hands. Their lips met for a mere moment and Doug felt as if he were floating. Carson’s lips were so soft, his breath so sweet and warm. His calloused fingers caressed Doug’s hot cheeks. The kiss ended too soon, and Doug felt the coolness sweep across his lips. “I’m sorry,” Carson said, letting go of Doug and taking a step backward.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What for?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I shouldn’t have presumed,” Carson said, wringing his hands again.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug put a hand on top of Carson’s to stop the twisting. “That was the most incredible moment. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson seemed to relax a little, his shoulders falling noticeably. “You said I could pick the place?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Place?” Doug’s brain was still a little fuzzy from the kiss. “Oh, right. For our date.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I hope you don’t mind, but I thought you might like to come out to my little farm. I run my landscaping business from there. And of course, please bring Paul, if you’d like.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“To our date?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson’s smile was a reflex. His laughter sent chills up and down Doug’s spine. “Technically, yes. But we won’t be doing much more than picnicking and playing with the animals. Unless, of course, you think I’m easy and cheap?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Doug’s smile faded almost instantly. “Oh, no, of course not. I—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I was kidding,” Carson said and brought up one of Doug’s hands to kiss it. “Is tomorrow too soon?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, not at all. It’s my day off tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good. Say, noon?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Noon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Great.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Great.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’ll see you then.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good night, Doug.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Night, Carson. And thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson flashed his million-dollar smile, walked backward through the door, and was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug took the closest seat and sat down, his heart racing.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t22"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t23"
  }, [_vm._v("OUG")]), _vm._v(" "), _c('span', {
    staticClass: "t23"
  }, [_vm._v("PULLED")]), _vm._v(" "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("the van into a secluded driveway, about twenty miles outside the city. The house was a half-wood, half-stone structure that spanned at least three hundred feet from end to end. He couldn’t help but wonder what the inside looked like. He imagined a huge central room, complete with a huge pair of overstuffed sofas that sat perpendicular to an enormous stone fireplace.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Big house,” Paul said from the back of the van.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s huge,” Doug said. He parked the van and turned off the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I bet there won’t be any ramps.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay, Mr. Cranky of Sour, Grumpy, and Cranky,” Doug said. He turned around to see his brother smiling. “I spoke with him this morning, and he said that his mother uses a wheelchair, and the entire house can accommodate yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hey, I made partner,” Paul joked as he waited for Doug to exit the van and let him out.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yeah,” Doug responded. “You’re still under review.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Doug came around the back just as Carson came from one of the little outbuildings opposite the huge house. Doug opened the back door, lowered the ramp, and stepped up to pull the wheelchair out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Any trouble finding the place?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t24"
  }, [_vm._v("“No, none at all,” Doug said, guiding the wheelchair down the ramp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He got lost, twice.” Paul said and laughed at the look Doug gave him. “What? You want to start your relationship with a lie?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t24"
  }, [_vm._v("Doug closed his eyes and shook his head. “Sorry,” he said, squinting at Carson. “He’s a little grumpy ’cause I wouldn’t let him drive.” The smile disappeared from Carson’s face. “It’s a little joke.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Practically microscopic,” Paul said in a stage whisper. “My favorite is when he tells me not to get up when the doorbell rings.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“You don’t, do you?” Carson had a smile on his face again as he looked at Doug. “I’m sorry, I don’t know why I’m smiling. That’s….”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Funny,” Paul said.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Tell him what you say about me all the time.” Doug was adjusting Paul in the chair, making sure he was aligned just right so he could breathe on his own.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t know what you’re talking about.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug finished fussing over his brother and cleared his throat. “Saint Paul, here, likes to tell people he ended up in this chair because he was Mom’s favorite and I was jealous.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“One thing you should know about him, Carson, is he’s a well-known liar.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I don’t think you should be joking about things like that,” Carson said, bringing a hand up to his lips to hide a smile. “That’s terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And when people are gullible enough to believe him and ask how? My younger brother, Pinocchio, tells them I ran over him with my Big Jim camper.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Whatever happened to Baby Paul?” Paul looked at Carson and winked.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson burst out laughing and quickly covered his mouth again. “I’m sorry, Paul. I’m really sorry. That’s not funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s fucking hilarious.” Paul was laughing, as well. “Honestly, you should see the look on some people’s faces. The way they look at Doug. It’s hysterical.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Not for Doug, I bet,” Carson said when he regained his composure. “You and my mother are going to get along great, Paul.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Am I allowed to explore while you two chat?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, the terrain around here is pretty drivable, and my mom doesn’t have any problem getting around, so feel free to explore.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug opened his mouth but lost his train of thought when he heard an unfamiliar sound. He looked around. Little fluffy balls of bouncing wool were leaving the barn. Sheep. Carson had sheep on his little farm. “You have sheep?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yeah. This is family land. Been that way for generations. Dad used to keep sheep for the wool. Long, boring story. I also have dogs. And Mom has a cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug looked down when Paul steered the wheelchair toward the sheep.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Should we follow him?” Carson looked back and forth between the brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sure,” Doug said. He folded the ramp and closed the door to the van. Then he made a quick stop for the backpack and fell into step with Carson. “He’s pretty independent, but I’m just worried about the chair tipping or getting stuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He seems to be in a better mood today,” Carson said, walking beside Doug. “I mean, he seems… his disposition isn’t… I didn’t mean that to sound so….”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug laughed and put a hand on Carson’s shoulder. “It’s okay. Truth is, he "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("is")]), _vm._v(" in a better mood today. Still not sure what had him so down yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("They both stopped about five feet behind Paul’s wheelchair and watched as the three lambs stood near Paul, assessing this new stranger to their part of the world. A mocha-colored lamb began to jump around, bleating in Paul’s direction, and Doug closed his eyes when he heard his brother laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That’s Mocha,” Carson said to Paul as the rest of the sheep joined in the bouncing and bleating. “The white one is Snow and the two spotted ones are East and West.” Paul moved his head as far as he could and looked up at Carson. “Family tradition. Another long story.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“How old are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Three weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“So sweet,” Paul said.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Here,” Carson said. He squatted down and wrapped his arms around Mocha. He used his left hand to hold the little lamb’s front legs, so she would not inadvertently kick Paul. “She likes licking and being petted. She thinks she’s a dog, apparently.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug stepped forward, ready to intervene, but Paul raised his left hand as high as he could, and Carson put Mocha underneath it. Mocha immediately started twisting her head from side to side, licking Paul’s wrist and forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“They’re adorable,” Doug said. He knelt and tried to catch one of the bouncing babies. He finally succeeded, stood up, and looked at Carson. “I did it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“She’s a feisty one. Be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("No sooner had Doug been warned than the little lamb headbutted him in the chin. Doug lowered her to the ground and stood beside Paul. “I guess I don’t have the magic touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What happened?” Paul looked at his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Headbutt right to the chin.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Do you have any other animals?” Paul asked Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Mom has a cat, and I have two dogs. A boxer and a bulldog.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Cool,” Paul said. Carson put Mocha back with her brothers and sister. “Took forever for Mom to agree to let us get Ralph.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson looked at Doug. “Mom thought they would compromise Paul’s immune system. We eventually wore her down, and Paul’s immune system was fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, no, no,” Paul said, and Doug laughed at the imitation. “You’ll develop allergies and then you’ll need even more medication.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Speaking of,” Doug said, looked at his watch, and reached into his backpack. He pulled out a clear-plastic pill organizer and a bottle of water. “Would you mind?” He asked Carson to hold the water bottle and the plastic container of pills. He reached back in for some hand sanitizer, put a dollop on his palm, and scrubbed for a few seconds. He took the plastic container and dumped the day’s pills into his palm. “Thank you,” he said as he took the bottle and turned to Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Can’t we skip them, just this once?” Paul pleaded.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No. You know what Dr. Graves is always telling you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Paul opened his mouth, and Doug popped the pills in and then held the bottle of water up to his brother’s lips. Paul swallowed, then opened his mouth and moved his tongue around.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug sighed and noticed the bewildered expression on Carson’s face. “Wait for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He makes me show him, otherwise he’ll turn my ventilator off tonight while I’m in bed and stand there saying, ‘It does what it’s told or it will not get any oxygen.’”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug closed his eyes again and shook his head. “Another of his all-time greatest hits.” Doug was relieved to see Carson hiding another smile, but he wondered how much more he would be able to tolerate before he kicked them both off his property.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You two should really develop an act,” Carson said, shaking his head. “Come on. Let’s go to the house. I’ll give you the tour, you can meet Mom, and then we can eat.” Carson walked beside Paul’s wheelchair. “By the way, Paul, I’ve set up the deck off the kitchen just so we could eat outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Awesome,” Paul said, straining to meet Carson’s gaze. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Mom likes to eat outside too.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Does she like to race with her wheelchair?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson looked at Doug, eyebrows raised.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug sighed. “Ignore him.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("“M")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OM")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(",” C")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("ARSON")]), _vm._v(" said, exasperated.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What? He asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He asked you how you like living out in the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“And I told him that it would be more enjoyable if I wasn’t the only one to keep you company. Doug?” Mrs. Oliver asked, ignoring her son’s stare. “Did you know that Carson cooked everything for this lunch? He spent most of the morning cleaning the deck and picking just the right tablecloth.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Really?” Doug said and looked at Carson. “It’s beautiful out here. And the food was excellent.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He certainly did,” she said, beaming. “Before he got into landscaping and those assholes canceled his TV show, Carson trained to be a chef.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It was really good,” Paul said. He sipped his iced tea through a long, curved straw that reminded Doug of the glass tubing from high school chemistry class. “How come we don’t have straws like this? Easier to reach.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I got them at Nico’s,” Carson said. “They’re just down the street from the bar. I can give you the address if you’d like.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That would be great. Thank you,” Doug said and sipped his own iced tea.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Must be wonderful to be out here at night. So peaceful. And to see all the stars.” Paul raised his eyes to the sky. He pushed a little button with his left hand and his chair tilted back a few degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He wouldn’t know,” Mrs. Oliver said. “He spends all his time working. Or playing rugby.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Mom,” Carson whispered. “I spend plenty of time out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Working,” she repeated. “Or with your teammates.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Such a shame, Carson. I can’t think of anything worse than having this and not making time to enjoy it.” Doug finally had an answer to the questions he’d been wanting to ask about the bruises on Carson’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Carson tells me you’re a waiter, Doug.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Have you always been a waiter?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, Mrs. Oliver,” Doug said, smiling for Carson’s sake. “I used to be a teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, I see,” she said and turned to look at Paul. “And what do you do, Paul?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m a stuntman,” Paul said and took another sip through the straw.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Anyone for dessert?” Carson was out of his chair in an instant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh,” Mrs. Oliver declared and clapped her hands together. “Carson makes the most wonderful cheesecakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry,” Carson said as he stood up. “I made a lemon posset with kiwi and raspberries.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Sounds wonderful,” Doug said as he stood. “Please, let me help you with the dishes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Paul, do you drink coffee?” Carson took his plate and his mother’s, leaving Doug to take his own and his brother’s.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No,” Paul said, pouting his lips. “The warden won’t let me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Surely, one small mug won’t hurt?” Mrs. Oliver turned her doe eyes to Doug.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“He gets upset when you call him "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Shirley")]), _vm._v(",” Paul said.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, I love that movie.” Mrs. Oliver clapped her hands again. “Carson, we have that one, don’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes. I’ll get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“One mug. Just one.” Doug had the plates in his hands and was looking at his brother. “But you know it might keep you up, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Yes, thank you, sir. I promise to be in the fields by dawn, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug shook his head, followed Carson into the kitchen, and placed the plates and cutlery on the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry about that,” Carson said, standing beside Doug.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I think she’s charming. And she’s obviously concerned about you.” Doug nudged Carson’s shoulder. “Now, if I could just keep Paul from making those stupid jokes. I’m afraid your mother might think I’m some sort of monster.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“No, she likes you.” Carson rested his backside against the counter. “As evidenced by her repeated attempts to let you know I’m out here with only her.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, I think she’s an absolute firecracker.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank you.” Carson turned to face Doug. “You’ve been a really good sport.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“My pleasure,” Doug said and found himself mesmerized, again, by Carson’s smile. “You really do have the most hypnotizing smile.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson’s face became serious and he opened a cupboard behind his head. “Thank you for the help with the dishes. I’ll get the dessert set out on plates and be right out.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug was momentarily confused, trying to think of what he could have done or said. “Okay,” he said finally and walked out to the deck.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("OUG")]), _vm._v(" "), _c('span', {
    staticClass: "t15"
  }, [_vm._v("WAS")]), _vm._v(" watching Mrs. Oliver in front of the large, flat-screen television. She was fast asleep, and Paul was beginning to nod off as well. He was about to push himself out of his chair and suggest he and Paul take their leave when Guinevere, the cat to whom Doug and Paul had been introduced, leaped from Mrs. Oliver’s lap, stretched, and trotted over to jump into his lap.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Hello, Guinevere.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Meow, meow, meow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Guinevere,” Carson chided, his expression stern as he glared at the cat. “I will tell him no such thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug raised his eyebrows and tried not to be too alarmed. “What did she say?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Oh, I’m sorry,” Carson said, moving closer to Doug on the sofa. “I keep forgetting that not everyone speaks Cat.” He wrinkled his nose and then added, “But, seriously, I don’t think you want to know. Let’s just say she was being very nosy and very inappropriate.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug’s expression must have betrayed his condescension.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You don’t believe me? Ask her yourself. She understands English, French, and of course, Cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug laughed and looked into the emerald green eyes of the beautiful, black, domestic shorthair. He rubbed behind her ears. “How old are you, sweetie?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Meow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Three,” Carson translated, raising an eyebrow. “You didn’t believe me that I speak Cat, I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Such a pretty name you have, Gwen,” Doug purred, luxuriating in the silky fur.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Meow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank you,” Carson said as Guinevere mewed again. “She prefers you use her entire name and not the vulgar "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Gwen")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course. Yes,” Doug said, trying not to laugh. “Où est la bibliothèque?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Meow, meow, meow, meow,” Guinevere howled, lifted her hind leg, and began to clean herself. Then, just as suddenly, she stopped, hopped off Doug’s lap, and disappeared into the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Did I say something wrong? I’m pretty sure that just means "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Where is the library")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“It’s okay,” Carson soothed. He rested a hand on Doug’s knee. “It’s a touchy subject for her. She just said that she doesn’t wish to talk about it and that she’ll never again step foot in that hovel of a library, nor renew her membership, on principle, until she receives a formal apology from that awful lady who had the nerve to imply that Guinevere’s mother was far too easy and that Guinevere is a gross misnomer for someone so un-princesslike.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug burst out laughing. “Such an efficient language.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry,” Carson said, smiling at him. “She’s very sensitive. I’ve tried to be supportive, but if she keeps this up, I may have to force her into therapy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug shook his head and covered his mouth. “Stop,” he wheezed. “You are too much.” He gained control of himself and wiped his eyes. “That was very funny,” he said, glad to still feel Carson’s hand on his knee. “You really do have the most beautiful smile.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Carson took back his hand and patted the cushion between them, welcoming the tan boxer, whose name Doug could not immediately remember. He felt as if he’d perhaps said something wrong, but didn’t want to press his luck.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("After another ten or fifteen minutes, Doug pushed himself to his feet, made his way to his brother, and announced that they should head back before it got too dark. Doug was always much more nervous driving Paul in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He and Paul said their good-byes to Mrs. Oliver and followed Carson to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t24"
  }, [_vm._v("“I’ll walk you out,” Carson said as Doug slipped into his shoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug wasn’t sure what to say. Everything had been going so well until he mentioned Carson’s smile. After that faux pas, Doug had become so self-conscious that he’d barely said anything at all. He watched that stupid movie, frantically trying to think of something to say to turn the clock back to when Carson stood close to him and let their arms brush against each other.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank you for lunch, Carson.” Paul was heading toward the van, ahead of his brother and their host.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You’re very welcome, Paul. And you’re welcome anytime.” Carson turned to Doug. “In fact, if you’d like, I can set one of the trees aside for you for Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“They’re thirty feet tall,” Paul exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t24"
  }, [_vm._v("“Not those ones,” Carson said with a chuckle. He pointed to a small patch of evergreens just beyond the front of the van. “Those ones.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“They’re beautiful,” Doug said. He opened the back door and pulled down the ramp. “We’ll be sure to come back out. Paul loves Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I think it’s the music,” Paul said. “Reminds me of Mom singing while she would bake all those cookies.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, you let me know which one you want, and I’ll make sure it’s waiting for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That’s very kind of you,” Doug said, maneuvering Paul’s wheelchair into the van. He made sure his brother was comfortable and then backed himself out, repositioned the ramp, and closed the door. “Thank you for a wonderful afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“My pleasure,” Carson said as he followed Doug to the front of the vehicle. Before he could open the door, Carson touched his elbow. “Listen, I know I haven’t made the best first, or second, or third, impression, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes,” Doug said, trying not to jump up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes what?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes, I’d love to see you again.” Carson was just staring at him. “That is what you were going to ask me, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Well, yes, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thank God,” Doug said and stood on his tiptoes to kiss Carson on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Wait, Doug, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t24"
  }, [_vm._v("Doug stood still and looked at Carson’s flushed cheeks. “What is it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I, uh, I really enjoy being with you, but, well, it’s been a long time since anyone has thought of me in… that way, and I just wanted to ask you to be… patient with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course,” Doug said. He shrugged and wondered why Carson felt the need to explain. "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("As long as you’re at the end of the path, I don’t care how long it is.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("And with that one word, Carson’s smile was back and as brilliant as the stars that were just beginning to peak out behind the dying sunlight. And as if that weren’t enough, Carson leaned forward and kissed him quickly and softly on the lips.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Will you call me and let me know you two got home safely?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Of course,” Doug said, willing to promise him anything he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("“S")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v("?” P")]), _c('span', {
    staticClass: "t15"
  }, [_vm._v("AUL")]), _vm._v(" asked from the back of the van as they made their way back to the city.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Did he kiss you or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Why does that matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“You like him, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What is this about, Paul?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Do you like him or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Yes,” Doug said, glancing in the rearview mirror to look at his brother. “I like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Good,” Paul said, a sincere smile on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Your turn.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“To explain why you’re asking me these questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m just curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug let the matter drop and concentrated on navigating the highways and then the city streets. When they were home, Doug would press a little harder to figure out if Carson was the reason Paul was acting so weird lately.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Okay,” Doug said. Paul was safely inside the house, all the doors were locked, and he had notified Carson of their safe return to the house. “You want to explain it to me now?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Don’t play stupid with me, Paul. Your IQ is higher than mine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“That’s just because you don’t apply yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Thanks, Mr. Paul. I wish all my teachers were as kind as you, Mr. Paul.” Doug sat on Paul’s bed, waiting for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Fine.” Paul sighed. “Promise me you won’t get mad?”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Paul, please. You’re scaring me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“When I’m gone, you’ll need someone, and you seem to really like Carson.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug looked into his brother’s eyes. It was like looking into his own. Their eyes were so similar. Doug had thought that maybe his brother was in a strange mood because he was worried about his own mortality, but Paul had long ago accepted his fate. He was worried about leaving Doug all alone.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug blinked rapidly and looked down at his knees. “I’m not talking about this,” he said. He pushed himself off the bed and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Dougie, I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug ended up in the kitchen. He opened the dishwasher and then slammed it shut when he saw it was empty. So was the sink. There was nothing to do in that room, nothing he could use to distract himself.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“I’m sorry.” Paul sat in the hallway, looking in at his brother. “I know it upsets you, but I can’t help that. And neither can you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Look,” Doug said. He turned abruptly and pointed a finger. “You told me only two days ago that they’re always wrong. We both know that…that….” "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("That what?")]), _vm._v(" "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("That Paul is going to die and you’ll have another fifty years to miss him and Mom and rage about how unfair it all is.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug felt his lower lip quiver. He turned and punched the wall, hoping he could give himself some other pain that would be greater. It didn’t work. He sank into the nearest chair and cried. He cried because there wasn’t a damn thing he could do to help his only brother, his only sibling. He cried because his brother had been cheated by some fucking protein that decided not to play by the rules, and he cried because somewhere in Europe was the prick who’d abandoned his family and left them to face this all alone.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("“Dougie, don’t cry. Please? You know what it does to me to see you cry.” Paul brushed the controller with his left hand and the chair came to a stop in front of Doug.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("Doug lowered his head and let it rest on his brother’s right hand. “I’m sorry, Paulie.” Doug didn’t know what he was sorry for, precisely. He was sorry that this had happened to his brother and not him. He was sorry that a brother’s and mother’s love hadn’t been enough to save him from a life of pain and suffering. He was sorry that he was weak—so weak that Paul had to be the strong one.")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_vm._v("He felt his brother’s left hand on his head and heard his brother’s sniffles, but he didn’t have the strength to stop crying.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47edcc68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/008.vue
// module id = 75
// module chunks = 0